class FilterItem {
    constructor(id, type, name, key) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.key = key;
    }
}

export default FilterItem;